export interface MpgRow {
  id: string;
  lotCode: string;
  productName: string;
  qty: number | null;
  causale: string;
  note: string;
}

const LOT_PREFIXES = ['DE', 'ES', 'ZE', 'CLA'] as const;
const PRODUCTS = [
  'WHITE WIDOW FIORE',
  'PURPLE HAZE FIORE',
  'CRISTALLO CBD',
  'OLIO CBD 10%',
  'OLIO CBD 5%',
  'BUBBLEGUM FIORE',
  'AMNESIA HAZE FIORE',
  'OLIO COSMETIC CBG',
  'POLLEN CBD',
  'HASHISH CBD',
];
const CAUSALI = ['PSC consumo', 'LNP rilavorazione', 'MSS spedizione', 'INV rettifica', 'Scarto QC'];

function pad(n: number, len: number): string {
  return String(n).padStart(len, '0');
}

export function generateMockMpgRows(count = 1000): MpgRow[] {
  const rows: MpgRow[] = [];
  for (let i = 0; i < count; i += 1) {
    const prefix = LOT_PREFIXES[i % LOT_PREFIXES.length]!;
    const seq = pad((i % 999) + 1, 3);
    const day = pad(((i % 28) + 1), 2);
    const month = pad(((i % 12) + 1), 2);
    const year = '26';
    const lotCode = `${prefix}${seq}${day}${month}${year}`;
    const productName = PRODUCTS[i % PRODUCTS.length]!;
    const qty = Math.round((Math.random() * 1000 + 1) * 10) / 10;
    const causale = CAUSALI[i % CAUSALI.length]!;
    rows.push({
      id: `row-${i}`,
      lotCode,
      productName,
      qty,
      causale,
      note: '',
    });
  }
  return rows;
}

export const KNOWN_LOT_CODES = new Set<string>(
  generateMockMpgRows(1000).map((r) => r.lotCode),
);
